export default __webpack_public_path__ + "static/media/neurology.f3af3043.jpg";